/* Types */
import type { ThemeDefinition } from 'vuetify'

/* Настройка для светлой темы */
const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {},
}

/* Настройка для темной темы */
const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {},
}

export default {
  ssr: true,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
}
